/* global axios */
// NOTICE: KAPTION-INTEGRATION - Feature Permissions (client-managed permission layer)

import ApiClient from './ApiClient';

class FeaturePermissionsAPI extends ApiClient {
  constructor() {
    super('kaption_feature_permissions', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(featurePermissions) {
    return axios.patch(this.url, { feature_permissions: featurePermissions });
  }
}

export default new FeaturePermissionsAPI();
